export default __webpack_public_path__ + "static/media/Project-4.91790e7e.jpg";